(function () {
const redirects = {
  "/products/prime": "/products/mens-fit-overs-new?fyf_variant=52031697486120",
  "/products/regal": "/products/mens-fit-overs-new?fyf_variant=52031727534376",
  "/products/horizon": "/products/mens-fit-overs-new?fyf_variant=52031753814312",
  "/products/atlas": "/products/mens-fit-overs-new?fyf_variant=52031775801640",
  "/products/valor": "/products/mens-fit-overs-new?fyf_variant=52031779897640",
  "/products/frontier": "/products/mens-fit-overs-new?fyf_variant=52031792873768",
  "/products/allure": "/products/ladies-fit-overs?variant=50709362311464",
  "/products/allure-halo": "/products/ladies-fit-overs?variant=50709362475304",
  "/products/velora": "/products/ladies-fit-overs?variant=50709362573608",
  "/products/serene": "/products/ladies-fit-overs?variant=50709362606376",
  "/products/eterna": "/products/ladies-fit-overs?variant=50709362868520",
  "/products/forte": "/products/ladies-fit-overs?variant=50709362901288",
  "/products/mens-fit-overs": "/products/mens-fit-overs-new"
};

  // Normalize path (strip trailing slash, except for root)
  const path = window.location.pathname.replace(/\/+$/, "");
  const target = redirects[path];

  if (target) {
    // Preserve query string, renaming variant -> fyf_variant
    const params = new URLSearchParams(window.location.search);
    if (params.has("variant")) {
      params.set("fyf_variant", params.get("variant"));
      params.delete("variant");
    }

    const qs = params.toString();
    const newUrl = target + (qs ? "?" + qs : "") + window.location.hash;

    window.location.replace(newUrl);
  }
})();